// Add your providers here for easy indexing.
export { TranslateProvider } from './translate/translate.service';
export { HotelProvider } from './hotel/hotel.service';
export { WeatherService } from './weather/weather.service';
export { CarsService } from './cars/cars.service';
export { ActivitiesService } from './activities/activities.service';
export { ContractService } from './contract/contract.service';
export { MemberService } from './member/member.service';
export { WordpressService  } from './wordpress/wordpress.service';
